import Service from "../../../Services/index";
import moment from "moment";


const RROrder = {
    namespaced: true,
    state: {
        table: [],
        data: [],
        rr_vendor: [],
        form: {
            RR_number: '',
            date: "",
            vendor: "",
            status_id: "",
            price: "",
            payment_date: "",
            credit_day: "",
            tax_rate: 0,
            tax_total: 0,
            total: 0,
            status_tax: null,
            total_tax: 0,
            other_discount: '',
            other_income: ''
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        search: {
            rr_number: "",
            date: [],
            vendor: "",
            status: "",
            amount: ""
        },
    },
    mutations: {
        GET_RR_ORDER: (state, res) => {
            state.table = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                rr_number: "",
                date: [],
                vendor: "",
                status: "",
                amount: ""
            }
        },
        GET_RR_ORDER_BY_ID: (state, res) => {
            state.data = res;
        },
        GET_RR_VENDOR: (state, res) => {
            state.rr_vendor = res.message;
        },
        CLEAR_FORM_STATE: state => {
            const currentDate = moment().format("YYYY-MM-DD");
            state.rr_vendor = [],
                state.form = {
                    RR_number: '',
                    date: currentDate,
                    vendor: null,
                    status_id: "",
                    price: "",
                    payment_date: currentDate,
                    credit_day: "",
                    tax_rate: 0,
                    tax_total: 0,
                    total: 0,
                    other_discount: '',
                    other_income: ''
                }
        },
    },
    actions: {
        setRROrder({commit}, page = 1) {
            return Service.RROrder.getRROrder(page).then(response => {
                commit("GET_RR_ORDER", response);
                commit("CLEAR_SEARCH");
            });
        },
        create({commit, state}, {details, user}) {
            let data = {
                RR_number: state.form.RR_number,
                date: state.form.date,
                vendor_id: state.form.vendor.id,
                status_id: 1,
                user_id: user,
                price: state.form.price,
                payment_date: state.form.payment_date,
                credit_day: state.form.credit_day,
                details: details,
                total_tax: state.form.total_tax,
                tax_rate: state.form.tax_rate,
                total: state.form.total,
                status_tax: state.form.status_tax,
                other_discount: state.form.other_discount,
                other_income: state.form.other_income
            };
            //console.log(data);
            return Service.RROrder.createRROrder(data);
        },
        show({commit}, id) {
            return Service.RROrder.showRROrder(id).then(response => {
                commit("GET_RR_ORDER_BY_ID", response)
            })
        },
        update({commit}, {id, data}) {
            return Service.RROrder.updateRROrder(id, data);
        },
        delete({commit}, id) {
            return Service.RROrder.deleteRROrder(id);
        },
        searchByVendor({commit}, vendor) {
            return Service.RROrder.searchByVendor(vendor).then(res => {
                commit("GET_RR_VENDOR", res)
            });
        },
        clearform({commit}) {
            commit("CLEAR_FORM_STATE");
        },
        search({commit}, {page = "", data}) {
            return Service.RROrder.search(page, data)
                .then(data => {
                    commit("GET_RR_ORDER", data);
                    // commit("CLEAR_SEARCH");
                })
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
        generateRR({commit}, date) {
            return Service.RROrder.generateRR(date);
        }
    }
};

export default RROrder;
